<template>
  <div :class="{'spl-parcel-detail-content__deleted' : parcel_json.Cancelled}" class="spl-parcel-detail-content">
    <div v-if="parcel_json && userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.VIEW)">
      <parcel-detail-header :content="header_content" @detailClosed="onDetailClosed" />
      <!-- *********************** Timeline *********************************** -->
      <div v-if="parcel_json.Cancelled" class="spl-parcel-detail-content__deleted--info">
        <div class="row">
          <div class="col12">
            <h1>This Parcel was Deleted!</h1>
            <form-button
              v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.REACTIVATE)"
              :wide="true"
              @onClick="onOpenReactivateParcelModal">
              Reactivate
            </form-button>
          </div>
        </div>
      </div>
      <div class="padding-wrapper">
        <div class="row" style="padding-top: 10px;">
          <!-- *********************** Maps Column *********************************** -->
          <div
            v-if="showMap"
            class="col4 sm-col12">
            <parcel-map
              v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.LIST)"
              :center="mapCenter"
              :url="mapUrl" />
          </div>
          <!-- *********************** Timeline Column *********************************** -->
          <div
            :class="{ col8: showMap, col12: !showMap }"
            class="sm-col12">
            <parcel-timeline
              v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.LIST)"
              :parcel-key="parcelKey"
              :reload="reload_timeline" />
          </div>
        </div>
      </div>

      <!-- *********************** Problem Reports *********************************** -->
      <div v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.VIEW)" class="padding-wrapper">
        <div class="row">
          <div class="col12">
            <parcel-detail-block-problem-report
              :original-parcel-json="parcel_json"
              label="Problem report"
              vertical="true"
              error="true"
              @parcelUpdated="get_updated_Parcel" />
          </div>
        </div>
      </div>

      <div class="padding-wrapper">
        <div class="row">
          <!-- *********************** Left Column *********************************** -->
          <div class="col4 sm-col12">
            <!-- General Info -->
            <parcel-detail-block
              :content="general_info_content"
              :original-parcel-json="parcel_json"
              :edit-in-progress="edit_in_progress"
              class="spl-detail__general-info"
              label="General info"
              @parcelUpdated="get_updated_Parcel" />
            <!-- Service Info -->
            <parcel-detail-block
              :highlight="external_delay"
              :content="service_info_content"
              :original-parcel-json="parcel_json"
              :edit-in-progress="edit_in_progress"
              class="spl-detail__service-info"
              label="Service info"
              @parcelUpdated="get_updated_Parcel" />
            <!-- Weight Dimensions -->
            <parcel-detail-block
              :highlight="no_data_highlight"
              :content="weight_dimensions_content"
              :original-parcel-json="parcel_json"
              :edit-in-progress="edit_in_progress"
              class="spl-detail__weight-dimensions"
              label="Weight & Dimensions"
              @parcelUpdated="get_updated_Parcel" />
            <!-- References -->
            <parcel-detail-block-references
              v-if="userHasPermission(constants.PERMISSION_TYPES.REFERENCE, constants.PERMISSION_VALUES.LIST)"
              :content="references_content"
              :original-parcel-json="parcel_json"
              :edit-in-progress="edit_in_progress"
              class="spl-detail__references"
              label="References"
              @parcelUpdated="get_updated_Parcel" />
            <!-- Routing -->
            <parcel-detail-block-routing
              v-if="userHasPermission(constants.PERMISSION_TYPES.TAG, constants.PERMISSION_VALUES.LIST) || userHasPermission(constants.PERMISSION_TYPES.PROVIDER, constants.PERMISSION_VALUES.LIST)"
              v-show="(parcel_json.Tags && parcel_json.Tags.length > 0) || (parcel_json.Providers && parcel_json.Providers.length > 0)"
              :content="parcel_json"
              class="spl-detail__routing"
              label="Routing" />
            <!-- Signatures -->
            <parcel-detail-block-signed-by
              v-if="signed_by_content !== ''"
              :content="signed_by_content"
              :original-parcel-json="parcel_json"
              class="spl-detail__signatures"
              label="Signatures" />

            <parcel-detail-block-loading-list
              v-if="userHasPermission(constants.PERMISSION_TYPES.REFERENCE, constants.PERMISSION_VALUES.LIST) && parcel_json.Loading_List"
              :original-parcel-json="parcel_json"
              :edit-in-progress="edit_in_progress"
              label="Loading List"
              class="spl-detail__loading-list"
              @parcelUpdated="get_updated_Parcel" />
          </div>
          <!-- *********************** Right Column *********************************** -->
          <div class="col8 sm-col12">
            <!-- Address Info -->
            <parcel-detail-block-address
              v-if="userHasPermission(constants.PERMISSION_TYPES.ADDRESS, constants.PERMISSION_VALUES.VIEW)"
              :content="address_content"
              :original-parcel-json="parcel_json"
              :edit-in-progress="edit_in_progress"
              label="Address info"
              class="spl-detail__address"
              content-blocks="true"
              @parcelUpdated="get_updated_Parcel" />
            <!--Delivery Information -->
            <parcel-detail-block-scans
              v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.LIST)"
              :content="delivery_info_content"
              :table="event_table_content"
              :parcel-details="parcel_json"
              :parcel-key="parcel_json.Parcel_ID"
              class="spl-detail__delivery-information"
              label="Delivery information"
              @parcelUpdated="get_updated_Parcel" />
            <!--Documents -->
            <parcel-detail-block-documents
              v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.LIST)"
              :content="documents_content"
              :parcel-key="parcel_json.Parcel_ID"
              class="spl-detail__documents"
              label="Documents" />
          </div>
        </div>
      </div>

      <!-- *********************** Action bar for selected parcels *********************************** -->
      <div class="parcel_action_bar_spacer">
        <div class="row">
          <div class="col12">
&nbsp;
          <!-- spacer to make sure parcel-action-bar doesnt cover important info. -->
          </div>
        </div>
      </div>
      <parcel-action-bar
        v-if="userHasActionBarPermissions()"
        :single-parcel="true"
        class="spl-parcel-detail-content__action-bar"
        @openDeleteParcelModal="onOpenDeleteParcelModal"
        @openReactivateParcelModal="onOpenReactivateParcelModal"
        @openUploadDocumentModal="onOpenUploadDocumentModal"
        @deactivateProblemReport="onDeactivateProblemReport"
        @openCreateCMRModal="onOpenCreateCMRModal" />

      <!-- *********************** Report Problem modal pane  *********************************** -->
      <create-problem-report-modal
        v-if="userHasPermission(constants.PERMISSION_TYPES.PROBLEM_REPORT, constants.PERMISSION_VALUES.CREATE)"
        :selected-rows="parcel_row"
        @problemReportCreated="get_updated_Parcel" />

      <file-upload-modal
        v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)"
        @fileUploaded="onFileUploaded" />

      <delete-parcel-modal
        v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.DELETE)"
        :parcels="parcelsToDelete"
        @parcelDeleted="onParcelDeleted" />

      <reactivate-parcel-modal
        v-if="userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.REACTIVATE)"
        :parcels="parcelsToReactivate"
        @parcelReactivated="onParcelReactivated" />

      <create-cmr-modal
        v-if="userHasPermission(constants.PERMISSION_TYPES.CMR, constants.PERMISSION_VALUES.CREATE)"
        :parcels="parcelsToCreateCMR"
        @cmrCreated="onCMRCreated" />
    </div>

    <!-- *********************** Load screen *********************************** -->
    <div v-else class="spl-load-img" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import webApi from '@/webApi'
import Helpers from '@/helpers.vue'
import constants from '@/constants'
import { find } from 'lodash'

export default {
  name: 'ParcelDetailContent',
  mixins: [Helpers],
  props: ['parcelKey'],
  data () {
    return {
      parcel_json: '',
      header_content: '',
      address_content: [],
      references_content: [],
      documents_content: [],
      general_info_content: [],
      weight_dimensions_content: [],
      external_delay: '',
      no_data_highlight: '',
      signed_by_content: '',
      delivery_info_content: [],
      event_table_content: [],
      reload_timeline: false,
      parcel_row: [],
      constants,
      edit_in_progress: false,
      parcelsToDelete: [],
      parcelsToReactivate: [],
      parcelsToCreateCMR: [],
      mapCenter: {},
      mapUrl: ''
    }
  },
  computed: {
    ...mapGetters('country', ['countryOptions']),
    ...mapGetters('customer', ['customerOptions']),
    ...mapGetters('serviceLevel', ['serviceLevelOptions']),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('reference', ['emptyReferenceValues']),
    showMap: function () {
      return this.hasMapDetails()
    }
  },
  created () {
    // Call the  methods
    if (this.isAuthenticated()) {
      this.parcel_row = [{ Parcel_ID: this.parcelKey }]
      // But only if the user is logged in.
      this.get_Parcel()
      this.get_Gps_Current_Position()
    }
  },
  mounted () {
    // Error Modal
    window.bus.$on('edit_in_progress', this.handleEditInProgress)
  },
  beforeDestroy () {
    window.bus.$off('edit_in_progress', this.handleEditInProgress)
  },
  methods: {
    ...mapActions('contact', ['getContacts']),
    handleEditInProgress () {
      this.edit_in_progress = !this.edit_in_progress
    },

    onDetailClosed () {
      this.$emit('detailClosed')
    },

    openUpdateParcelsModal () {
      this.$emit('detailClosed', true, this.parcel_json)
    },

    onOpenDeleteParcelModal () {
      this.parcelsToDelete = [this.parcel_json]
    },

    onParcelDeleted () {
      this.$emit('reloadParcelList')
      this.$emit('detailClosed')
    },

    onOpenReactivateParcelModal () {
      this.parcelsToReactivate = [this.parcel_json]
    },

    onParcelReactivated () {
      this.$emit('reloadParcelList')
      this.$emit('detailClosed')
    },

    onOpenCreateCMRModal () {
      this.parcelsToCreateCMR = [this.parcel_json]
    },

    onCMRCreated () {
      this.parcelsToCreateCMR = []
      this.get_updated_Parcel()
    },
    onOpenUploadDocumentModal () {
      window.bus.$emit('openFileUploadModal', [this.parcel_json.Parcel_ID])
    },

    bookReturn () {
      this.$router.push('/parcel-book/' + this.foundCounterNumber)
    },

    /**
     * Function for deactivate the Problem reports for the selected parcels
     */
    onDeactivateProblemReport () {
      webApi.problem_report.deactivate_Problem_Reports_In_Parcel_List([this.parcel_json.Parcel_ID])
        .then((response) => {
          this.$toast('Problem Report was deactivated', constants.defaultToastOptions())
          this.get_Parcel()
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },

    onFileUploaded () {
      this.get_updated_Parcel()
    },

    // ************************ Get the parcel ************************
    // Calls the API to get the  parcel details and sets all the contents
    // for the components
    get_updated_Parcel () {
      this.reload_timeline = true
      this.get_Parcel()
      this.get_Gps_Current_Position()
    },
    get_Parcel () {
      // Get the Parcel Details
      this.parcel_row = [{ Parcel_ID: this.parcelKey }]
      webApi.parcel.get_Parcel_Details_By_ID(this.parcelKey)
        .then((response) => {
          // Get the json from the response
          this.parcel_json = response.data
          // Call the methods to update the contents
          this.set_Header()
          this.set_General_Info()
          this.set_Service_Info()
          this.set_Weight_Dimensions()
          this.set_Delivery_Info()
          this.set_Signed_By()

          if (this.userHasPermission(constants.PERMISSION_TYPES.ADDRESS, constants.PERMISSION_VALUES.VIEW)) {
            this.set_Address_Info()
          }
          if (this.userHasPermission(constants.PERMISSION_TYPES.REFERENCE, constants.PERMISSION_VALUES.LIST)) {
            this.set_References()
          }
          if (this.userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.LIST)) {
            this.set_Documents()
          }
          if (this.userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.LIST)) {
            this.set_Events()
          }

          this.getContacts({
            customerID: this.parcel_json.Customer_ID,
            countryID: this.parcel_json.Country_ID
          })

          this.reload_timeline = false
          this.$forceUpdate()
        }).catch((response) => {
          // // eslint-disable-next-line no-console
          // console.log(response)
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },
    // get the GPS coordinates
    get_Gps_Current_Position () {
      webApi.anonymous_tracking.get_Current_Gps_Position_By_Parcel_Id(this.parcelKey)
        .then((response) => {
          // Get the json from the response
          const current_position_json = response.data
          if (current_position_json != null && current_position_json.Latitude !== 0.0 && current_position_json.Longitude !== 0.0) {
            this.mapCenter = { lat: current_position_json.Latitude, lng: current_position_json.Longitude }
            this.mapUrl = ''
          } else
          if (current_position_json !== null && current_position_json.Map_Url !== '') {
            this.mapCenter = {}
            this.mapUrl = current_position_json.Map_Url
          }

          this.reload_timeline = false
          this.$forceUpdate()
        }).catch((response) => {
          window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        })
    },

    // ************************ Set the header************************
    // Set the header data
    set_Header () {
      for (var value in this.parcel_json.References) {
        if (this.parcel_json.References[value].Reference_Type_ID === constants.REFERENCE_TYPE_ID.COUNTER_NUMBER) {
          this.foundCounterNumber = this.parcel_json.References[value].Reference_Text
        }
      }
      this.header_content = {
        counter_number: this.foundCounterNumber,
        deadline: this.formatDate(this.parcel_json.Close_Deadline, true, 'YYYY-MM-DD HH:mm'),
        current_event: this.parcel_json.Current_Status_Event_Name,
        current_event_timestamp: this.formatDate(this.parcel_json.Current_Status_Event_Timestamp, true, 'YYYY-MM-DD HH:mm'),
        current_event_user: this.parcel_json.Current_Status_Event_User_Name,
        signed_by_name: this.parcel_json.Signed_By_Name,
        is_forward: this.parcel_json.Is_Forward,
        direction_switch_parcel_id: this.parcel_json.Is_Forward ? this.parcel_json.Return_Parcel_ID : this.parcel_json.Original_Parcel_ID
      }
    },
    // ************************ Check if there are available coordinates in events ************************
    hasMapDetails () {
      return (this.mapCenter && this.mapCenter.lat != null && this.mapCenter.lng != null) || this.mapUrl !== ''
    },

    // ************************ Set the address block ************************
    set_Address_Info () {
      for (var value in this.parcel_json.Contact) {
        if (this.parcel_json.Contact[value] != null && this.parcel_json.Contact[value] !== 'NULL') {
          this.contact_value += '\n' + this.parcel_json.Contact[value]
        }
      }

      if (this.contact_value === '') {
        this.contact_value = 'n/a'
      }

      this.address_content = {
        pickup_address_id: this.parcel_json.Delivery_Address_ID,
        delivery_address_id: this.parcel_json.Delivery_Address_ID,
        contact: this.contact_value
      }
    },
    // ************************ Set the reference block ************************
    // Set the references for the details page
    set_References () {
      this.references_content = []
      this.emptyReferenceValues.forEach((value) => {
        var presentReference = find(this.parcel_json.References, { Reference_Type_ID: value.Reference_Type_ID })
        this.references_content.push({
          field_label: value.Reference_Type_Name,
          field_key: value.Reference_Type_ID,
          value: presentReference ? presentReference.Reference_Text : value.Reference_Text,
          editable: value.Reference_Type_ID !== constants.REFERENCE_TYPE_ID.COUNTER_NUMBER
        })
        if (!presentReference) {
          this.parcel_json.References.push({
            Reference_Type: value.Reference_Type_Name,
            Reference_Text: value.Reference_Text,
            Reference_Type_ID: value.Reference_Type_ID
          })
        }
      })
    },

    // ************************ Set the General Info block ************************
    // Set the General Info for the details page
    set_General_Info () {
      this.general_info_content = []
      this.general_info_content.push(
        {
          field_label: constants.REFERENCE_TYPE_NAME.PARCEL_ID,
          field_key: 'parcel-id',
          value: this.parcel_json.Parcel_ID,
          editable: false
        }
      )
      for (var value in this.parcel_json.References) {
        if (this.parcel_json.References[value].Reference_Type_ID === constants.REFERENCE_TYPE_ID.COUNTER_NUMBER) {
          this.general_info_content.push({
            field_label: this.parcel_json.References[value].Reference_Type,
            field_key: this.parcel_json.References[value].Reference_Type_ID,
            label: this.parcel_json.References[value].Reference_Type,
            value: this.parcel_json.References[value].Reference_Text,
            editable: false
          })
        }
      }
      this.general_info_content.push(
        {
          field_label: constants.PARCEL_FIELD_LABELS.BOOKED_PICKUP_DATE,
          field_key: 'pickup-date',
          value: this.formatDate(this.parcel_json.Booked_Pickup_Date, false, 'YYYY-MM-DD'),
          editable: true,
          type: 'only_datepicker'
        },
        {
          field_label: constants.PARCEL_FIELD_LABELS.CUSTOMER,
          field_key: 'customer',
          value: this.parcel_json.Customer_ID,
          label: this.parcel_json.Customer_Name,
          editable: true,
          type: 'dropdown',
          options: this.customerOptions
        },
        {
          field_label: constants.PARCEL_FIELD_LABELS.COUNTRY,
          field_key: 'country',
          value: this.parcel_json.Country_ID,
          label: this.parcel_json.Country_Name,
          editable: true,
          type: 'dropdown',
          options: this.countryOptions
        }
      )
    },
    // Set the documents for the details page
    set_Documents () {
      this.documents_content = []
      for (var value in this.parcel_json.Documents) {
        this.documents_content.push({
          selected: false,
          filename: this.parcel_json.Documents[value].Original_File_Name,
          description: this.parcel_json.Documents[value].Document_Description,
          documentID: this.parcel_json.Documents[value].Document_ID
        })
      }
    },
    set_Service_Info () {
      // Check if there is an external delay
      if (this.parcel_json.External_Delay === true) {
        this.external_delay = 'An External Delay has been reported.'
      }
      this.service_info_content = [
        {
          field_label: constants.PARCEL_FIELD_LABELS.DANGEROUS_GOODS,
          field_key: 'dangerous-goods',
          value: this.parcel_json.Dangerous_Goods,
          editable: true,
          type: 'checkbox'
        },
        {
          field_label: constants.PARCEL_FIELD_LABELS.XRAYED,
          field_key: 'xrayed',
          value: this.parcel_json.XRayed,
          editable: true,
          type: 'checkbox'
        },
        {
          field_label: constants.PARCEL_FIELD_LABELS.Last_Mile_Upgrade,
          field_key: 'lastmileupgrade',
          value: this.parcel_json.Last_Mile_Upgrade,
          editable: true,
          type: 'checkbox'
        },
        {
          field_label: constants.PARCEL_FIELD_LABELS.SERVICE_LEVEL,
          field_key: 'service-level',
          value: this.parcel_json.Service_Level_ID,
          label: this.parcel_json.Service_Level_Name,
          editable: true,
          type: 'dropdown',
          options: this.serviceLevelOptions.concat()
        },
        {
          field_label: constants.PARCEL_FIELD_LABELS.OPEN_DEADLINE,
          field_key: 'open-deadline',
          value: this.formatDate(this.parcel_json.Open_Deadline, true, 'YYYY-MM-DD HH:mm'),
          editable: true,
          type: 'datepicker'
        },
        {
          field_label: constants.PARCEL_FIELD_LABELS.CLOSE_DEADLINE,
          field_key: 'close-deadline',
          value: this.formatDate(this.parcel_json.Close_Deadline, true, 'YYYY-MM-DD HH:mm'),
          editable: true,
          type: 'datepicker'
        }
      ]
    },

    set_Weight_Dimensions () {
      this.weight_dimensions_content = []
      // Add the dimensions data
      var missingWeightOrVolume = false
      if (this.parcel_json.Volume === '' || this.parcel_json.Weight === '') {
        missingWeightOrVolume = true
      }

      // Add the length
      this.weight_dimensions_content.push({
        field_label: constants.PARCEL_FIELD_LABELS.LENGTH,
        field_key: 'length',
        value: this.parcel_json.Length > 0 ? this.parcel_json.Length : 'n/a',
        type: 'float',
        editable: true
      })
      // Add the Width
      this.weight_dimensions_content.push({
        field_label: constants.PARCEL_FIELD_LABELS.WIDTH,
        field_key: 'width',
        value: this.parcel_json.Width > 0 ? this.parcel_json.Width : 'n/a',
        type: 'float',
        editable: true
      })
      // Add the Width
      this.weight_dimensions_content.push({
        field_label: constants.PARCEL_FIELD_LABELS.HEIGHT,
        field_key: 'height',
        value: this.parcel_json.Height > 0 ? this.parcel_json.Height : 'n/a',
        type: 'float',
        editable: true
      })

      // Add the volume data

      this.weight_dimensions_content.push({
        field_label: constants.PARCEL_FIELD_LABELS.VOLUME,
        field_key: 'volume',
        value: this.parcel_json.Volume > 0 ? this.parcel_json.Volume : 'n/a',
        type: 'float',
        editable: true
      })

      // Add the weight
      this.weight_dimensions_content.push({
        field_label: constants.PARCEL_FIELD_LABELS.WEIGHT,
        field_key: 'weight',
        value: this.parcel_json.Weight > 0 ? this.parcel_json.Weight : 'n/a',
        type: 'float',
        editable: true
      })

      if (this.parcel_json.Booked_Length !== this.parcel_json.Length ||
          this.parcel_json.Booked_Height !== this.parcel_json.Height ||
          this.parcel_json.Booked_Width !== this.parcel_json.Width ||
          this.parcel_json.Booked_Volume !== this.parcel_json.Volume ||
          this.parcel_json.Booked_Weight !== this.parcel_json.Weight) {
        // Add the booked length
        this.weight_dimensions_content.push({
          field_label: constants.PARCEL_FIELD_LABELS.BOOKED_LENGTH,
          field_key: 'booked_length',
          value: this.parcel_json.Booked_Length > 0 ? this.parcel_json.Booked_Length : 'n/a',
          type: 'float',
          editable: false
        })
        // Add the booked Width
        this.weight_dimensions_content.push({
          field_label: constants.PARCEL_FIELD_LABELS.BOOKED_WIDTH,
          field_key: 'booked_width',
          value: this.parcel_json.Booked_Width > 0 ? this.parcel_json.Booked_Width : 'n/a',
          type: 'float',
          editable: false
        })
        // Add the booked Width
        this.weight_dimensions_content.push({
          field_label: constants.PARCEL_FIELD_LABELS.BOOKED_HEIGHT,
          field_key: 'booked_height',
          value: this.parcel_json.Booked_Height > 0 ? this.parcel_json.Booked_Height : 'n/a',
          type: 'float',
          editable: false
        })

        // Add the booked volume data
        this.weight_dimensions_content.push({
          field_label: constants.PARCEL_FIELD_LABELS.BOOKED_VOLUME,
          field_key: 'booked_volume',
          value: this.parcel_json.Booked_Volume > 0 ? this.parcel_json.Booked_Volume : 'n/a',
          type: 'float',
          editable: false
        })

        // Add the booked weight
        this.weight_dimensions_content.push({
          field_label: constants.PARCEL_FIELD_LABELS.BOOKED_WEIGHT,
          field_key: 'booked_weight',
          value: this.parcel_json.Booked_Weight > 0 ? this.parcel_json.Booked_Weight : 'n/a',
          type: 'float',
          editable: false
        })
      }

      // Show a message if the data is missing
      if (missingWeightOrVolume) {
        this.no_data_highlight = 'We are missing weight and dimension data.'
      }
    },

    set_Delivery_Info () {
      // Check if there are problem_reports
      this.delivery_info_content = [
        {
          label: constants.PARCEL_FIELD_LABELS.PICKUP_TIME,
          value: this.formatDate(this.parcel_json.Pickup_Timestamp, true, 'YYYY-MM-DD HH:mm'),
          editable: false
        },
        {
          label: constants.PARCEL_FIELD_LABELS.DELIVERY_TIME,
          value: this.formatDate(this.parcel_json.Delivery_Timestamp, true, 'YYYY-MM-DD HH:mm'),
          editable: false
        },
        {
          label: constants.PARCEL_FIELD_LABELS.ENGINEER_PICKUP_TIME,
          value: this.formatDate(this.parcel_json.Engineer_Pickup, true, 'YYYY-MM-DD HH:mm'),
          editable: false
        },
        {
          label: constants.PARCEL_FIELD_LABELS.CURRENT_LOCATION,
          value: this.parcel_json.Current_Status_Event_Name,
          editable: false
        },
        {
          label: constants.PARCEL_FIELD_LABELS.SCANNED_AT,
          value: this.formatDate(this.parcel_json.Current_Status_Event_Timestamp, true, 'YYYY-MM-DD HH:mm'),
          editable: false
        },
        {
          label: constants.PARCEL_FIELD_LABELS.SCANNED_BY,
          value: this.parcel_json.Current_Status_Event_User_Name,
          editable: false
        }
      ]
    },
    // Set the documents for the details page
    set_Events () {
      this.event_table_content = []
      for (var value in this.parcel_json.Events) {
        this.event_table_content.push({
          selected: false,
          event_id: this.parcel_json.Events[value].Event_ID,
          milestone: this.parcel_json.Events[value].Event_Info.Milestone_Name || '-',
          event_info_id: this.parcel_json.Events[value].Event_Info_ID,
          position: this.parcel_json.Events[value].Event_Info.Event_Info_Name || '-',
          type: this.parcel_json.Events[value].Event_Info.Event_Type_Name || '-',
          timestamp: this.formatDate(this.parcel_json.Events[value].Timestamp, true, 'YYYY-MM-DD HH:mm') || '-',
          user: this.parcel_json.Events[value].User_Name || '-',
          note: this.parcel_json.Events[value].Note || '-',
          active: this.parcel_json.Events[value].Active,
          signed_by: this.parcel_json.Events[value].Signed_By
        })
      }
    },
    // Set the signed by for the details page
    set_Signed_By () {
      if (
        (this.parcel_json.Signed_By_Name != null && this.parcel_json.Signed_By_Name !== '') ||
        (this.parcel_json.Signed_By_File != null && this.parcel_json.Signed_By_File !== '')
      ) {
        this.signed_by_content = [
          {
            label: 'Signed By Name',
            value: this.parcel_json.Signed_By_Name,
            signature_picture: this.parcel_json.Signed_By_File
          }
        ]
      } else {
        this.signed_by_content = ''
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../variables.scss';
  .spl-parcel-detail-content {
    padding-bottom: 40px;
    @include mobile () {
      &__action-bar {
        display: block;
        position: initial;
      }
    }

    &__book-return {
      & .spl-button {
        width: calc(100% - 20px);
        margin: 10px;
      }
    }
    &__deleted {
      .padding-wrapper {
        opacity: 0.5;
      }
      &--info {
        padding: 0 70px;
        background-color: $errorRedBackground;
        h1 {
          font-size: 25px;
          width: 100%;
          padding: 15px;
          text-align: center;
        }
      }
    }
  }
</style>
